const FETCH_UPDATING_MERCHANT_REQUEST = 'FETCH_UPDATING_MERCHANT_REQUEST';
const FETCH_UPDATING_MERCHANT_SUCCESS = 'FETCH_UPDATING_MERCHANT_SUCCESS';
const FETCH_UPDATING_MERCHANT_ERROR = 'FETCH_UPDATING_MERCHANT_ERROR';

const HIDE_SETTLEMENT_LOADER = 'HIDE_SETTLEMENT_LOADER';
const SHOW_SETTLEMENT_LOADER = 'SHOW_SETTLEMENT_LOADER';

export {
    FETCH_UPDATING_MERCHANT_REQUEST,
    FETCH_UPDATING_MERCHANT_SUCCESS,
    FETCH_UPDATING_MERCHANT_ERROR,
    HIDE_SETTLEMENT_LOADER,
    SHOW_SETTLEMENT_LOADER,
};
